import { Injectable } from '@angular/core';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { AAMVAWithdrawalErrorDetail } from '../../helpdesk/models/aamva-withdrawal-error-detail.model';
import { UpdateProhibitionIncidentsRequest } from '../../helpdesk/models/update-prohibition-incidents-request.model';
import { AAMVAProhibition } from '../../helpdesk/models/aamva-prohibition.model';
import { CreateOOSWCorrespondenceRequest } from '../../driverrecord/models/create-oosw-correspondence-request.model';
import { CreateOOSCCorrespondenceRequest } from '../../driverrecord/models/create-oosc-correspondence-request.model';
import { CreateMVRHistoryReportRequest } from '../../helpdesk/models/create-mvr-history-report-request.model';
import { SearchWithdrawalsAAMVACustomersRequest } from '../../helpdesk/models/search-withdrawals-aamva-customers-request.model';
import { ProhibitionAAMVAConfiguration } from '../../helpdesk/models/prohibition-aamva-configuration.model';

@Injectable()
export class ProhibitionAAMVAService extends BaseApiService {

    public getLookups() {
        return this.get('Prohibition/AAMVA/Lookups');
    }

    public processAAMVAWithdrawalErrorDetail(aamvaWithdrawalErrorDetail: AAMVAWithdrawalErrorDetail) {
        return this.post('Prohibition/AAMVA/AAMVAWithdrawalErrorDetail', aamvaWithdrawalErrorDetail);
    }

    public saveAAMVAWithdrawalDetail(aamvaProhibition: AAMVAProhibition) {
        return this.post('Prohibition/AAMVA/AAMVAWithdrawalDetail', aamvaProhibition);
    }

    public updateProhibitionIncidents(request: UpdateProhibitionIncidentsRequest) {
        return this.post('Prohibition/AAMVA/AAMVAProhibitionIncidents/Update', request);
    }

    public searchUnlinkedWithdrawalsAAMVACustomers(request: SearchWithdrawalsAAMVACustomersRequest) {
        return this.post('Prohibition/AAMVA/UnlinkedWithdrawals/AAMVACustomers', request);
    }

    public saveProhibitionAAMVAConfiguration(request: ProhibitionAAMVAConfiguration) {
        return this.post('Prohibition/AAMVA/ProhibitionAAMVAConfiguration', request);
    }

    public getCustomersAAMVAProhibitions(customerNumberId: number) {
        return this.get('Prohibition/AAMVA/Customer/' + customerNumberId + '/AAMVAProhibitions');
    }

    public getAAMVAProhibition(customerNumberId: number, prohibitionId) {
        return this.get('Prohibition/AAMVA/Customer/' + customerNumberId + '/Prohibition/' + prohibitionId);
    }

    public createOOSWReport(createOOSWCorrespondenceRequest: CreateOOSWCorrespondenceRequest) {
        return this.post('Prohibition/AAMVA/OOSWReport', createOOSWCorrespondenceRequest);
    }

    public createOOSCReport(createOOSCCorrespondenceRequest: CreateOOSCCorrespondenceRequest) {
        return this.post('Prohibition/AAMVA/OOSCReport', createOOSCCorrespondenceRequest);
    }

    public printOOSC(createOOSCCorrespondenceRequest: CreateOOSCCorrespondenceRequest) {
        return this.post('Prohibition/AAMVA/PrintOOSC', createOOSCCorrespondenceRequest);
    }

    public printOOSW(createOOSWCorrespondenceRequest: CreateOOSWCorrespondenceRequest) {
        return this.post('Prohibition/AAMVA/PrintOOSW', createOOSWCorrespondenceRequest);
    }

    public createMVRDocument(request: CreateMVRHistoryReportRequest) {
        return this.post('Prohibition/AAMVA/CreateMVRDocument', request);
    }
}
